import { IDropDownOptionsWithDescription } from "../Component/Common/Components/FormValidationInputs/AppSelectListWithInfo";
import { IDropDownTabOptions } from "../Component/Common/Components/OptionsSelectDropdown/OptionsSelectDropdown";
import { StaticDataModel } from "../Component/Model/Dto/StaticData";

export function getIOptionsArrayWithInfo<T extends Record<K, number | string>, K extends keyof T>(
    data: T[],
    idProp: K,
    nameProp: K,
    descriptionProp: K, 
    additionalDescription?: K
): IDropDownOptionsWithDescription[] {
    if (data === null || data === undefined) return [];
    return data.map((item: T) => {
        const id = item[idProp] as number;
        const value = item[nameProp] as string;
        const description = item[descriptionProp] as string;

        if(additionalDescription !== undefined)
        {
            const descriptionLine2 = item[additionalDescription] as string;
            return { id: id, value: value, description: description, descriptionLine2: descriptionLine2};
        }
        else {
            return { id: id, value: value, description: description};
        }
});
}


export function getIOptionsArray<T extends Record<K, number | string>, K extends keyof T>(
    data: T[],
    idProp: K,
    nameProp: K
): IDropDownTabOptions[] {
    if (data === null || data === undefined) return [];
    return data.map((item: T) => {
        const id = item[idProp] as number;
        const value = item[nameProp] as string;
        return { id: id, value: value };
    });
}

export function getIStaticData<T extends Record<K, number | string>, K extends keyof T>(
    data: T[],
    idProp: K,
    nameProp: K
): StaticDataModel[] {
    if (data === null || data === undefined) return [];
    return data.map((item: T) => {
        const id = item[idProp] as number;
        const value = item[nameProp] as string;
        return { Id: id, Name: value };
    });
}